import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-1 text-left" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm font-bold text-neutral50 m-0"
}
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = ["data-testid", "aria-pressed", "onClick"]
const _hoisted_5 = {
  key: 1,
  class: "text-xs text-neutral50 m-0"
}

interface SegmentedOption<V extends string> {
  label: string
  value: V
  /** Contador opcional exibido ao lado do label (ex: quantidade de itens da opção). */
  count?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SegmentedControl',
  props: {
    modelValue: {},
    options: {},
    label: {},
    help: {},
    testIdPrefix: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;

/**
 * Segmentado de duas ou três opções mutuamente exclusivas, como nos mockups do Eixo 3 da
 * discovery de auditoria: a escolha inteira fica visível, ao contrário de um `v-select`, o que
 * importa quando as opções mudam o processo (quem confere a folha, aprovar sozinho ou não).
 *
 * `aria-pressed` em vez de `role="radio"`: são botões de ação imediata sobre um valor único, e
 * é o atributo que o teste lê para saber qual está ativo.
 */





function optionTestId(value: T): string | undefined {
  if (!props.testIdPrefix) return undefined
  return `${props.testIdPrefix}-${String(value).toLowerCase()}`
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: "inline-flex w-fit rounded-lg border border-gray-200 bg-gray-50 p-0.5",
      role: "group",
      "aria-label": _ctx.label || undefined
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createElementBlock("button", {
          key: String(option.value),
          type: "button",
          class: _normalizeClass(["inline-flex items-center gap-1.5 px-3 py-1.5 text-sm rounded-md transition-colors whitespace-nowrap", 
          option.value === _ctx.modelValue
            ? 'bg-white text-primary30 font-bold shadow-sm'
            : 'text-neutral50 hover:text-primary30'
        ]),
          "data-testid": optionTestId(option.value),
          "aria-pressed": option.value === _ctx.modelValue ? 'true' : 'false',
          onClick: ($event: any) => (_ctx.$emit('update:modelValue', option.value))
        }, [
          _createTextVNode(_toDisplayString(option.label) + " ", 1),
          (option.count !== undefined)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(option.value === _ctx.modelValue ? 'text-primary30 font-semibold' : 'text-gray-400')
              }, _toDisplayString(option.count), 3))
            : _createCommentVNode("", true)
        ], 10, _hoisted_4))
      }), 128))
    ], 8, _hoisted_3),
    (_ctx.help)
      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.help), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})